import {
  NOTIFICATIONSENTAS_DIGITAL_LETTER,
  NOTIFICATIONSENTAS_EMAIL,
  NOTIFICATIONSENTAS_PHYSICAL_LETTER,
  NOTIFICATIONSENTAS_UNKNOWN,
} from '../constants/api';

export const notificationSentAsResolver = (
  translator,
  notificationSentAs,
  isSentToQueue,
) => {
  if (!isSentToQueue) {
    return null;
  }
  switch (notificationSentAs) {
    case NOTIFICATIONSENTAS_EMAIL:
      return translator('notificationSentAs.email');
    case NOTIFICATIONSENTAS_DIGITAL_LETTER:
      return translator('notificationSentAs.digitalLetter');
    case NOTIFICATIONSENTAS_PHYSICAL_LETTER:
      return translator('notificationSentAs.letter');
    case NOTIFICATIONSENTAS_UNKNOWN:
    default:
      return translator('notificationSentAs.unknown');
  }
};
